import React, { useState, useEffect, memo, useRef } from "react";
import { Row, Col } from 'reactstrap';
import { useForm } from "react-hook-form";
import {axiosFetch, postFormRequest} from "../../../../Utils/AxiosFetch";
import { handlingCatchError } from "../../../../Utils/ErrorHandling";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, IconButton, Radio, FormControlLabel, Checkbox } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { apiCommonTrigger } from "../../../../Utils/apiServicehelper";
import { Config } from "../../../../Utils/Config";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const FormDialog = memo((props) => {
  const navigate = useNavigate();
  const openChild = props.openChild;
  const choosenPackage = props.choosenPackage;
  const existUserDetail = props.userDetail;
  const { handleSubmit, control, watch, register } = useForm();
  const password = useRef({});
  password.current = watch("password", "");
  const [userDetails, setUserDetails] = React.useState({});
  const [firstNameErr, setFirstNameErr] = React.useState('');
  const [lastNameErr, setLastNameErr] = React.useState('');
  const [phoneErr, setPhoneErr] = React.useState('');
  const [isLoading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(existUserDetail?.userlogo || null);
  const [error, setError] = useState('');
  const [twofaEnable, setTwofaEnable] = useState(existUserDetail.is2faenabled);
    const [open, setOpen] = useState(false); // To Enable/Disable Snackbar
    const [snackClr, setSnackClr] = React.useState("");
    const [snackMsg, setSnackMsg] = React.useState("");
  

  useEffect(() => {
  setTwofaEnable(existUserDetail.is2faenabled);
}, [existUserDetail]);

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
  const onChangeValidation = (e) => {
    // First name validation
    if (e.target.name === 'firstname') {
      var regName = /^[A-Za-z\/\s\.'-]+$/;
      var name = e.target.value;
      if (name.length === 0) {
        setFirstNameErr('First name required');
      } else {
        if (!regName.test(name)) {
          setFirstNameErr('Invalid character');
        } else {
          setFirstNameErr('');
        }
      }
    }

    // Last name validation
    if (e.target.name === 'lastname') {
      var regName = /^[A-Za-z\/\s\.'-]+$/;
      var name = e.target.value;
      if (name.length === 0) {
        setLastNameErr('Last name required');
      } else {
        if (!regName.test(name)) {
          setLastNameErr('Invalid character');
        } else {
          setLastNameErr('');
        }
      }
    }


    //phone
    if (e.target.name === 'phone') {
      var string = e.target.value;
      var replacedString = e.target.value.replace(/-/g, "").replace("(", "").replace(")", "");
      var spaceRemovedStr = string.replace(/ /g, '');
      var numericRegex = /^([0-9]*)$/;
      var valid = numericRegex.exec(replacedString);

      if (valid) {
        string = replacedString;
        var regex = replacedString.length === 10 ? /^([^\s]{3})([^\s]{3})+([^\s]{4})+$/g : replacedString.length === 11 ? /^([^\s]{3})([^\s]{3})+([^\s]{5})+$/g : replacedString.length === 12 ? /^([^\s]{3})([^\s]{3})+([^\s]{6})+$/g : replacedString.length === 13 ? /^([^\s]{3})([^\s]{3})+([^\s]{7})+$/g : replacedString.length === 14 ? /^([^\s]{3})([^\s]{3})+([^\s]{8})+$/g : replacedString.length === 15 ? /^([^\s]{3})([^\s]{3})+([^\s]{9})+$/g : /^([^\s]{3})([^\s]{3})+([^\s]{9})+$/g;
        var match = regex.exec(string);
        if (match) {
          match.shift();
          match[0] = "(" + match[0] + ")";
          string = match.join("-");
          if (replacedString.length >= 16) {
            setPhoneErr('Invalid number');
          } else {
            setPhoneErr('')
          }
        } else {
          if (replacedString.length >= 16) {
            setPhoneErr('Invalid number');
          } else {
            setPhoneErr('');
          }
        }

      } else if (spaceRemovedStr.length > 0) {
        setPhoneErr('Invalid number');
      }
      if (string === "") {
        setPhoneErr('Phone is required');
      }
    }
    setUserDetails({ ...userDetails, [e.target.name]: e.target.name === 'phone' ? string : e.target.value });

  }

  useEffect(() => {
    setUserDetails({ ...userDetails, firstname: existUserDetail.firstname, lastname: existUserDetail.lastname, companyname: existUserDetail.company, phone: existUserDetail.phone });
  }, []);
   const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const formUpdate = () => {
    setLoading(true);

    const formDataToSubmit = new FormData()
    formDataToSubmit.append('FirstName', userDetails.firstname)
    formDataToSubmit.append('LastName', userDetails.lastname)
    formDataToSubmit.append('Company', userDetails.companyname ? userDetails.companyname : '')
    formDataToSubmit.append('Password', "") // If password is empty, can also omit it from the request
    formDataToSubmit.append('Phone', userDetails.phone);
    formDataToSubmit.append('is2faenabled',twofaEnable)
    if(existUserDetail.showuserlogo){
      if(fileName){
        formDataToSubmit.append('userlogo', fileName);
      }   
      if(file){
        formDataToSubmit.append('file', file);
      }  
    }
    if(props.id){
      formDataToSubmit.append('userid', props.id);
    }
let url = props.id?"/admin/updateuser":"/account/updateuser"
    postFormRequest({ url: url, requestConfig: formDataToSubmit }, true)
      .then((res) => {
       
        if (res.status === 200 && res.data === "success") {
       setLoading(false);
       setOpen(true); 
        setSnackClr("success");
         setSnackMsg("Account Details Updated Successfully");
         setTimeout(()=>{
          props.closeChild(false);
          props.refresh();
         },2000)
         
}

        else{
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        setLoading(false);
        handlingCatchError(err, navigate);
      })
  }

  const formSubmission = () => {
    setLoading(true);
       apiCommonTrigger("post",`${Config.API_URL}/subscription/add`, {
           "firstname":userDetails.firstname,
        "lastname":userDetails.lastname,
        "company":userDetails.companyname ? userDetails.companyname : '',
        "emailaddress":userDetails.email,
        "password": userDetails.password,
        "confirmpassword": userDetails.confirmpassword,
        "lookupkey": choosenPackage,
        "phone": userDetails.phone
          }) 
      .then((res) => {
        // return res;
        if (res.status === 200) {
          if(res.data === "success"){
            setLoading(false);
            window.location.replace(res.headers.location);
          }
        }
        else{
          setLoading(false);
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        setLoading(false);
        handlingCatchError(err, navigate);
      })
  }

  // Form submission
  const onHandleSubmit = (e) => {
    e.preventDefault();
    // if (!firstNameErr && !lastNameErr && !emailErr && !pwdErr && !confirmPwdErr && !phoneErr && userDetails.firstName && userDetails.lastName && userDetails.email && userDetails.phone && userDetails.password && userDetails.confirmPassword) {
    if (!firstNameErr && !lastNameErr && !phoneErr && userDetails.firstname && userDetails.lastname && userDetails.phone) {
      setLoading(true);
      formUpdate();
      // axiosFetch({
      //   method: "GET",
      //   url: "/home/validatesignupemail/"+userDetails.email,
      // }).then((res) => {
      //     if (res.status === 200) {
      //         if (res.data.isexist === false) {
      //           setLoading(false);
      //           formSubmission();
      //         } else {
      //             setLoading(false);
      //             setEmailErr('Email already linked to an existing RV Parks account. Please use a different email address.')
      //         }
      //     }
      //     if (res.status === 401) {
      //       setLoading(false);
      //       navigate("/");
      //     }
      // })
      // .catch(error => {
      //   setLoading(false);
      //   console.log(error);
      // });
      
    }else{
      if(firstNameErr === '' && !userDetails.firstname){
        setFirstNameErr('Please fill out this field');
      }
      if(lastNameErr === '' && !userDetails.lastname){
        setLastNameErr('Please fill out this field');
      }
      if(emailErr === '' && !userDetails.email){
        setEmailErr('Please fill out this field');
      }
      if(pwdErr === '' && !userDetails.password){
        setPwdErr('Please fill out this field');
      }
      if(confirmPwdErr === '' && !userDetails.confirmpassword){
        setConfirmPwdErr('Please fill out this field');
      }
      if(phoneErr === '' && !userDetails.phone){
        setPhoneErr('Please fill out this field');
      }
    }
  }

  const handleFileChange = (e) => {
    const newFiles = e.target.files[0];
    let updatedFiles = {file};
    let tempErrors = "";

    if (newFiles.size > 1 * 1024 * 1024) { // 1 MB limit
      tempErrors = `${newFiles.name} exceeds 1MB size limit`;
      setError(tempErrors);
    } else {
      setError('');
      setFileName(newFiles.name);
    setFile(newFiles);
    }
    
};

const removeFile = (index) => {
  setError('');
  setFileName(null);
  setFile(null);
};

  return (
    <div>
      {isLoading ? (
          <div className="loader-wrap">
          <div className="default-page loading loading-center"></div>
          </div>
      ) : (
          ""
      )}
      <Dialog open={openChild} className="modal-custom-popup">
        <form id='RVParkIQ_free_account_form'>
          {/* <DialogTitle>Enter Account Details</DialogTitle> */}
          <DialogTitle>Account Details</DialogTitle>
          <DialogContent>
            <Row>
              <Col>
                <TextField
                  label="First Name"
                  id="outlined-required"
                  fullWidth
                  value={userDetails.firstname ? userDetails.firstname : ''}
                  name="firstname"
                  onChange={(e) => onChangeValidation(e)}
                  error={!!firstNameErr}
                  helperText={firstNameErr ? firstNameErr : null}
                  margin="normal"
                  required
                  className="textbox-custom"
                />
              </Col>
              <Col>
                <TextField
                  label="Last Name"
                  id="outlined-required"
                  fullWidth
                  value={userDetails.lastname ? userDetails.lastname : ''}
                  name="lastname"
                  onChange={(e) => onChangeValidation(e)}
                  error={!!lastNameErr}
                  helperText={lastNameErr ? lastNameErr : null}
                  margin="normal"
                  required
                  className="textbox-custom"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <TextField
                  label="Company Name"
                  id="outlined-required"
                  fullWidth
                  value={userDetails.companyname ? userDetails.companyname : ''}
                  name="companyname"
                  onChange={(e) => onChangeValidation(e)}
                  margin="normal"
                  className="textbox-custom"
                />
              </Col>
              <Col>
                <TextField
                  label="Phone Number"
                  id="outlined-password-input"
                  margin="normal"
                  fullWidth
                  value={userDetails.phone ? userDetails.phone : ''}
                  name="phone"
                  onChange={(e) => onChangeValidation(e)}
                  error={!!phoneErr}
                  helperText={phoneErr ? phoneErr : null}
                  required
                  className="textbox-custom"
                />
              </Col>
            </Row>
            {existUserDetail && existUserDetail.showuserlogo ?
            <Row>
              <Col className="submit_missing_popup">
              <div className="upload-container mt-2 d-flex">
                          <div className="upload-area" id="uploadArea">
                            <FontAwesomeIcon
                              icon={faCloudArrowUp}
                              style={{ color: 'gray' }}
                            />
                            <div>
                              {error ? (
                                <Typography variant="body2" color="error">
                                  {error ? error : fileName }
                                </Typography>
                              ) : (
                                <Typography variant="body2" color="textSecondary" style={{ marginLeft: '10px' }}>
                                  Attach supporting documents (.jpeg/.jpg/.png/.gif), this helps with our uploading process.
                                </Typography>
                              )}
                            </div>
                            <input
                              type="file"
                              id="fileInput"
                              onChange={handleFileChange}
                              multiple
                              accept=".jpeg, .jpg, .png, .gif"
                              disabled={false}
                              style={{ marginTop: '10px', display: 'block' }}
                            />
                            <div className="file-list-container" style={{ marginTop: '10px' }}>
                                  { fileName ?
                                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '5px' }}>
                                        <Typography variant="body2" style={{ marginLeft: '10px' }}>
                                          {fileName ? fileName : ''}
                                        </Typography>
                                        <IconButton
                                          aria-label="remove file"
                                          onClick={() => removeFile()}
                                          style={{ marginLeft: '10px' }}
                                        >
                                          <FontAwesomeIcon icon={faXmark} style={{ fontSize: '15px' }} />
                                        </IconButton>
                                      </div>
                              : 
                                <Typography variant="body2" color="textSecondary">
                                  No files uploaded yet.
                                </Typography>
                              }
                            </div>
                           
                          </div>
               
                        </div>
              </Col>
            </Row>: ''}
           {props.id || props.isAdmin?(<> <FormControlLabel
               control={
               <Checkbox
               checked={twofaEnable}
                onChange={(e) => setTwofaEnable(e.target.checked)}
                 />
                 }
                 label="Two Factor Authentication"
                 />
              </>):""}


          </DialogContent>
          <DialogActions>
            <Button onClick={() => props.closeChild(false)} className="reset-opt">Cancel</Button>
            <Button type="submit" onClick={(e)=> onHandleSubmit(e)} className="market-btn">Submit</Button>
            {/* <Button onClick={handleClose}>Subscribe</Button> */}
          </DialogActions>
        </form>
      </Dialog>
       <Snackbar
              open={open}
              autoHideDuration={2000}
              onClose={handleClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
              <Alert onClose={handleClose} severity={snackClr} sx={{ width: "100%" }}>
                {snackMsg}
              </Alert>
            </Snackbar>
    </div>
  );
});

export default FormDialog;